
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Logout from '../../../containers/Pages/Login/Logout'
import { Button, message } from 'antd'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { CloseOutlined, LeftCircleOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row } from 'react-bootstrap'
import { Input } from 'antd'
import { payoutLandataChanelWiseAction, payoutPartnerChannelWiseLansearch } from '../../../redux/PayoutLanData/Action'
import { use } from 'react'
import LanListCETChanelWiseWithPayout from './LanListCETChanelWiseWithPayout'
import { debounce } from "lodash";
import useSession from '../../CustomLogout/useSession'

export const LanlistCETDetailChannel = (props) => {
  const navigate = useNavigate();
  const { reportId } = useParams();
  const handleSessionExpired = useSession();
  const [landatasource, setLanDatasource] = useState([]);
  const [makerAction, setMakerAction] = useState(false);
  const [checkerAction, setCheckerAction] = useState(false);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100', '200'],
  });






  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };


  const totalPageSizeSet = useRef(false);
  
  const debouncedSearch = useMemo(() =>
      debounce(async (value) => {
          const searchValue = String(value || "").trim().toLowerCase();
  
          if (!searchValue) {
              setPagination(prev => ({
                  ...prev,
                  current: 1,
                  pageSize: 10,
              }));
              await fetchPayoutLandataChanelWise(1, 10);
              totalPageSizeSet.current = false;
              return;
          }
  
          try {
             
              
              const sizeToUse = totalPageSizeSet.current
                  ? pagination.pageSize
                  : 400;
  
              let response = await props.payoutPartnerChannelWiseLansearch({
                  accessToken: props.accessToken,
                  reportId: reportId,
                  searchString: searchValue,
                  page: 0,
                  size: sizeToUse,
              });
  
              const errorCode = response?.response?.status || response.errorCode;
              if (
                  errorCode &&
                  errorCode === 403 &&
                  (response?.response?.status || response.errorCode)
              ) {
                  handleSessionExpired();
                  return;
              }
  
              const searchData = response.content || [];
              setLanDatasource(searchData);
  
              
              if (!totalPageSizeSet.current || response.totalElements !== pagination.total) {
                  setPagination(prev => ({
                      ...prev,
                      current: 1,
                      total: response.totalElements,
                      pageSize: response.totalElements > 0 ? response.totalElements : 10,
                  }));
                  totalPageSizeSet.current = true;
              }
  
              message.info(`Found ${response.totalElements} results`);
          } catch (error) {
              console.error("Search error:", error);
              message.error("Search failed. Please try again.");
          }
      }, 300),
      [props.accessToken, reportId, pagination.pageSize]
  );
  

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTextTable(value);
    debouncedSearch(value);
  };

  const fetchPayoutLandataChanelWise = async (current, pageSize) => {
    setDownloading(true);
    try {
      const response = await props.payoutLandataChanelWiseAction({
        accessToken: props.accessToken,
        reportId: reportId,
        page: current - 1,
        records: pageSize,
      });
      const errorCode = response?.response?.status || response.errorCode;
      if (
        errorCode &&
        errorCode === 403 &&
        (response?.response?.status || response.errorCode)
      ) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }

      if (response) {
        setLanDatasource(response.content || []);
        setPagination((prev) => ({
          ...prev,
          current: current,
          pageSize: pageSize,
          total: response.totalElements,
        }));
      }

    } catch (error) {
      console.error("Error fetching payout landata:", error);
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    const run = async () => {
      await fetchPayoutLandataChanelWise(pagination.current, pagination.pageSize);
    };
    run();
  }, [reportId]);

  const handlePageChange = async (page, pageSize) => {
    // Call the API with the new page and pageSize
    const res = await fetchPayoutLandataChanelWise(page, pageSize);
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize,
    }));
    // setPagination((prev) => ({
    //   ...prev,
    //   total: res?.totalElements,
    // }));
  };

  return (
    <div style={{ maxWidth: "100%" }}>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            <Button
              type="default"
              style={{
                margin: "0",
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '2px', // space between icon and text
                padding: '0 8px',
                color: '#00b1b1',
              }}
              onClick={() => navigate(-1)}
            >
              <LeftCircleOutlined />
              Back
            </Button>
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>
      <Row className='d-flex justify-content-end'>
        <Col
          md={3}
          style={{
            display: "flex",
            float: "right",
            marginTop: "100px",
            // justifyItems: "end",
            // alignItems: "end",
            justifyContent: "flex-end",
          }}
        >
          <Input
            //  disabled={!searchlandatasource.length}
            className="search-input"
            allowClear
            placeholder="Search..."
            suffix={<SearchOutlined />}

            value={searchTextTable}
            onChange={handleSearch}
            style={{ width: 200 }}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "20px" }}>
        <LanListCETChanelWiseWithPayout
          landatasource={landatasource}
          pagination={pagination}
          onPageChange={handlePageChange}
          downloading={downloading}
        />
      </Row>
    </div>
  )
}



const mapStateToProps = (state) => {
  // console.log('stateData:', state.pricigPartner.state.partnerDetail);
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    payoutLandataChanelWiseAction: (data) => dispatch(payoutLandataChanelWiseAction(data)),
    payoutPartnerChannelWiseLansearch: (data) => dispatch(payoutPartnerChannelWiseLansearch(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanlistCETDetailChannel)